const log = require("../shared_utils/log.js");
const { sanitizeSelections } = require("./utils/sanitize-state.js");
module.exports = function store(state, emitter) {
  function isEventOnDropArea(event) {
    if (!event.composedPath()) {
      return false;
    }
    const DROP_AREA_CLASSES = ["glitch-drop-areas-wrapper", "next-level-message"];
    return event.composedPath().find(
      (element) =>
        element &&
        element.classList &&
        DROP_AREA_CLASSES.some((cls) => element.classList.contains(cls))
    );
  }

  emitter.on("clear-state", () => {
    state.movingGlitch = false;
    state.movingPart = false;
    state.pickingGlitch = false;
    state.pickingPart = false;

    state.movingSelectedTarget = false;
    state.resizingSelectedTarget = false;
    state.rotatingSelectedTarget = false;
    state.applyingGlitch = false;
    state.hoverRotation = 0;
    state.hoveringTargetId = null;
    state.draggingGlitchApplication = false;
    state.importingPart = false;
  });
  emitter.on("deselect-all", () => {
    log("deselect-all");
    if (!state.glitchEditorOpen) {
      state.isInventoryOpen = true;
      state.currentVariablePage = 0;
      state.showLevelsPanel = false;
      emitter.emit("toggle-inventory");
      emitter.emit("close-menu");
      emitter.emit("deselect-part");
      emitter.emit("deselect-target");
      emitter.emit("deselect-glitch");
    }
  });
  emitter.on("drag-glitch-off-play-area", () => {
    state.draggingGlitchOutOfPlayArea = true;
  });

  emitter.on("complete-drag-action", (e) => {
    log("complete-drag-action", e);
    if (state.draggingSceneId) {
      state.draggingSceneId = null;
    } else
    if (state.draggingGlitchOutOfPlayArea) {
      if (!isEventOnDropArea(e)) {
        emitter.emit("drop-to-trash");
      }
      state.draggingGlitchOutOfPlayArea = false;
    }
    if (state.draggingSpriteVariable) {
      emitter.emit("set-selected-sprite-variable", e);
      state.draggingSpriteVariable = false;
      state.selectedSpriteVariable = null;
    }
    
    if (state.draggingTargetOutOfPlayArea) {
      if (!isEventOnDropArea(e)) {
        emitter.emit("delete-selected-sprite");
      } else {
        emitter.emit("put-target-back-in-play-area");
      }
    }
    if (state.movingSelectedTarget) {
      const target = state.vm.runtime.targets.find(
        (t) => t.id === state.selectedTargetId
      );
      if (target) {
        const body = state.vm.runtime.physicsData.bodies[target.id];
        if (body && body.cachedVelocity) {
          body.SetLinearVelocity(body.cachedVelocity);
          body.cachedVelocity = null;
        }
      } else {
        state.selectedTargetId = null;
        state.movingSelectedTarget = false;
      }
    }
    
    if (state.movingGlitch || state.movingPart || state.applyingGlitch || state.importingPart){
      if (!isDropOnToolbarOrGamescreen(e)) {
        if (state.selectedPartId) {
          emitter.emit("remove-part-from-toolbar", state.selectedPartId);
        } else {
          emitter.emit("remove-glitch-from-toolbar", state.selectedGlitchId);
        }
      }
    }
    emitter.emit("clear-state");

    setTimeout(() => emitter.emit("render"), 1);
  });

  function isDropOnToolbarOrGamescreen(e) {
    return e.composedPath().find(
      (element) =>
        element &&
        element.classList &&
        (element.classList.contains("toolbar") ||
          element.classList.contains("gamescreen"))
    );
  }

  emitter.on("clear-hovering-target", () => {
    state.hoveringTargetId = null;
    emitter.emit("render");
  });

  emitter.on("render", () => {
    // throw new Error('render in deselect')
    sanitizeSelections(state);
  });
};
